import React from "react";
import { Mic, ArrowUpRight, Mail, Phone } from "lucide-react";
import { SPEAKER_URL, SPEAKER_IMAGE, speakingTopics } from "../mock";
import useReveal from "../hooks/useReveal";

export default function Speaking() {
  const [ref, inView] = useReveal();

  return (
    <section id="speaking" data-testid="speaking-section" className="bg-[#3A0F7A] py-16 md:py-20">
      <div
        ref={ref}
        className={`reveal ${inView ? "in-view" : ""} mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-5 md:px-8 lg:grid-cols-2 lg:gap-14`}
      >
        <div className="overflow-hidden rounded-2xl shadow-2xl">
          <img
            src={SPEAKER_IMAGE}
            alt="Rachelle Koulibaly speaking at a women's conference in Montreal"
            className="h-72 w-full object-cover md:h-[420px]"
          />
        </div>

        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2">
            <Mic className="h-4 w-4 text-[#48B6F7]" />
            <span className="text-xs font-extrabold tracking-[0.12em] text-white">
              FOR SCHOOLS, CONFERENCES & ORGANIZATIONS
            </span>
          </div>
          <h2 className="mt-5 font-serif-display text-3xl font-bold leading-tight text-white md:text-[2.5rem]">
            Invite Rachelle to Speak
          </h2>
          <p className="mt-4 max-w-lg text-[15px] leading-relaxed text-[#E3DDF7]">
            Bring practical, real-life strategies to your parents, educators and
            community. Rachelle speaks in English and French, in person or virtually,
            and every talk leaves your audience with tools they can use the same day.
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {speakingTopics.map((t) => (
              <span key={t} className="rounded-full border border-white/20 px-3.5 py-1.5 text-[12px] font-semibold text-white">
                {t}
              </span>
            ))}
          </div>

          <a
            href={SPEAKER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="speaking-book-btn"
            className="mt-8 inline-flex items-center gap-2 rounded-md bg-white px-7 py-3.5 font-serif-display text-sm font-bold tracking-wide text-[#6618D0] shadow-sm transition-colors hover:bg-[#F3EEFC]"
          >
            BOOK RACHELLE AS A SPEAKER <ArrowUpRight className="h-4 w-4" />
          </a>

          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-[13px] text-[#E3DDF7]">
            <a data-testid="speaking-email-link" href="mailto:koulrachelle09@gmail.com" className="inline-flex items-center gap-2 hover:text-white">
              <Mail className="h-4 w-4" /> koulrachelle09@gmail.com
            </a>
            <a data-testid="speaking-phone-link" href="tel:+15875854685" className="inline-flex items-center gap-2 hover:text-white">
              <Phone className="h-4 w-4" /> 587-585-4685
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
